import React, {memo} from 'react';
//import {Avatar, MenuProps, message} from 'antd';
//import {ClearOutlined} from "@ant-design/icons";
//import ViewerOptionContext from "../../../../context/ViewerOptionContext";
import WizTooltip from "../../../../../Common/component/WizTooltip/WizTooltip";
import {stringToColor} from "../../../../../Common/util/ColorUtil";
import {Avatar} from "antd";
import {JwtSession} from "../../../../../Common/types/JwtSession";
import {AvatarSize} from "antd/es/avatar/AvatarContext";

interface UserAvatarProps {
    tooltip?:string,
    avatarText?:string,
    avatarSize?:AvatarSize,
}

const UserAvatar = (props:UserAvatarProps) => {
    const { tooltip, avatarText, avatarSize } = props;

    const jwtSessionStorage = sessionStorage.getItem("jwtSession");
    const jwtSession: JwtSession|null = jwtSessionStorage? JSON.parse(jwtSessionStorage) as JwtSession : null;

    const avtText:string            =   avatarText || `${jwtSession?.userName}`;
    const tooltipText:string        =   tooltip || `${jwtSession?.userId} - ${jwtSession?.userName}`;
    const avatarName = ():string =>
    {
        const spaceIndex = avtText.indexOf(' ');

        // If a space is found, return the substring before the first space
        if (spaceIndex !== -1) {
            return avtText.substring(0, spaceIndex);
        }

        // If there's no space, remove the first character and return the rest
        return avtText.substring(1);
    }
    /*

        const items:MenuProps['items'] = [
            {
                key: 'CHANGE_THEME',
                label: '테마',
                icon: <ClearOutlined />,
            },
        ];
        const handleMenuClick: MenuProps['onClick'] = (e) => {

            const key:string = e.key;
            message.info(`${key} Click on menu item.`);
            console.log('click', e);

        };

        const menuProps = {
            items,
            onClick: handleMenuClick,
        };


     */
    return (
        <WizTooltip title={ tooltipText } >
            <Avatar style={{ backgroundColor: stringToColor(avtText), verticalAlign: 'middle', cursor:'pointer' }} size={avatarSize||"large"}>
                <b>{avatarName()}  </b>
            </Avatar>
        </WizTooltip>
    );

    /*
    return (

        <Dropdown
            placement="bottomRight"
            menu={menuProps}
        >

            <Avatar style={{ backgroundColor: stringToColor(props.userName), verticalAlign: 'middle', cursor:'pointer' }} size={getAvataSize()}>
                <b>{avatarName(props.userName)}  </b>
            </Avatar>
        </Dropdown  >
    );

     */
};

export default memo(UserAvatar);